import React from "react";

const Education = () => {
  return (
    <div className='content'>
      Ph.D. : Computer Engineering, at Hacettepe University, Ankara, Türkiye,
      2019.
      <br />
      M.Sc. : Computer Engineering, at Dokuz Eylül University, İzmir, Türkiye,
      2011.
      <br />
      B.Sc. : Computer Engineering, at Selçuk University (highest ranked
      student), Konya, Türkiye, 2007.
      <br />
    </div>
  );
};

export default Education;
